import React, { Component ,useState } from 'react';
import { Modal, Button, Tabs, Tab, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import { TextField } from '@rmwc/textfield';
import { Checkbox } from '@rmwc/checkbox';
import { connect, useDispatch } from 'react-redux';
import { Radio } from '@rmwc/radio';
import { Select } from '@rmwc/select';
import AddEditBillingInfo from "./common/AddEditBillingInfo.js";
import * as actionCreator from "../../../action/quote_order/leadcustomer.action.js"
import * as validate from '../validations';
import {editUserAddress,AddCustomerLeadRecord,AddEditAddressRecord,EditCustomerLeadRecord} from "../../../action/quote_order/leadcustomer.action.js"
import AlertBox from '../AlertBox/AlertBox.js';
import { const_var } from '../../../redux/reducers/reducer.js';
import AnimButton from '../../Button/AnimButton.js';

const ShowAddressDetail = (detail) => {
    const dispatch = useDispatch();
    let userDetail = detail?.detail?.LeadCustomerData
    let address = userDetail?.address?.length > 0 && userDetail.address.map((item) => {
        if(detail.type == "Installation"){
            if(item.is_installation == 1){
                item["is_installation"] = 1
                item["is_billing"] = item.is_billing ? 1 : 0
            }else{
                if((const_var.crmSetting.is_Edit == false || const_var.prevModuleType) && item.is_default == 1 && item.is_installation == undefined){
                    item["is_installation"] = 1
                }else{
                    item["is_installation"] = 0
                }
            }
        }
        if(detail.type == "Billing"){
            if(item.is_billing == 1 ){
                item["is_billing"] = 1
                item["is_installation"] = item.is_installation ? 1 : 0
            }else{
                if((const_var.crmSetting.is_Edit == false || const_var.prevModuleType) && item.is_default == 1 && item.is_billing == undefined){
                    item["is_billing"] = 1
                }else{
                    item["is_billing"] = 0
                }
            }
        }
        return item
    })
    const [installAddress , setInstallAddress] = useState(0)
    const [BillingAddress , setBillingAddress] = useState(0)
    let addressCount = detail.type == "Installation" ? installAddress : BillingAddress
    let addressType = detail.type == "Installation" ? "installation" : "billing"
    const decreament = (type) => {
        if(addressCount >= 1){
            if(type == "Installation"){
                setInstallAddress(installAddress - 1)
            }else{
                setBillingAddress(BillingAddress - 1)
            }
        }
    }

    const increament = (type) => {
        if(addressCount + 1 < address?.length){
            if(type == "Installation"){
                setInstallAddress(installAddress + 1)
            }else{
                setBillingAddress(BillingAddress + 1)
            }
        }
    }

    const renderTooltip = (props , title) => {
        return(
            <Tooltip id="button-tooltip" {...props}>
                {title != undefined ? title : "-"}
            </Tooltip>
        )
    }

    return(
        <>
            <div className='row'>
                <div className='col-8'>
                    <h1 className='title mt-1'>{detail.type == "Installation" ? "Installation Address" : "Billing Address"}</h1>
                </div>
                {
                    address?.length > 1 &&
                        <div className='col-4 text-right'>
                            <span className='title address-count'>
                                <span class="icon-back arrow" onClick={() => decreament(detail.type)}></span>
                                <span classname="current-address"> {addressCount + 1}/{address?.length} </span>
                                <span class="icon-next arrow" onClick={() => increament(detail.type)}></span>
                            </span>
                        </div>
                }
            </div>
            <div className='col-12 p-0 mb-4'>
                <div className='address-card flex'>
                    {
                        userDetail.address?.length > 0 && 
                            <span className='set-type'>
                                {  detail.type == "Installation" 
                                    ?
                                        <span className={address[addressCount]?.is_installation == 1 ? 'default' : "mark-as-default" }
                                              onClick={(e) => dispatch(editUserAddress(e, "setAsDefault", "is_default" , addressCount , addressType === "installation" ? "shipping" : "billing"))}
                                              >Use for this order</span> 
                                    :
                                        <span className={address[addressCount]?.is_billing == 1 ? 'default' : "mark-as-default" }
                                                onClick={(e) => dispatch(editUserAddress(e, "setAsDefault", "is_default" , addressCount , addressType === "installation" ? "shipping" : "billing"))}
                                                >Use for this order</span>
                                }
                            </span>
                    }
                    <div className='col-10'>
                        <div className='row'>
                            <div className='col-4 label'>
                                First Name
                            </div>
                            <div className='col-8 value'>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(e)=> renderTooltip(e,userDetail.first_name)}
                                >
                                <span variant="success">{userDetail.first_name ? userDetail.first_name : "-" }</span>
                            </OverlayTrigger>                                 
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4 label'>
                                Last Name
                            </div>
                            <div className='col-8 value'>
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(e)=> renderTooltip(e,userDetail.last_name)}
                                >
                                <span variant="success">{userDetail.last_name ? userDetail.last_name : "-"}</span>
                            </OverlayTrigger>                                    
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4 label'>
                                Email
                            </div>
                            <div className={userDetail.email ? 'col-8 value email' : "col-8 p-0"} >
                            <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(e)=> renderTooltip(e,userDetail.email)}
                                >
                                <span variant="success">{userDetail.email ? userDetail.email : "-"}</span>
                            </OverlayTrigger>                     
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4 label'>
                                Phone
                            </div>
                            <div className='col-8 value'>
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(e)=> renderTooltip(e,userDetail.phone_no)}
                                    >
                                    <span variant="success">{userDetail.phone_no ? userDetail.phone_no : "-"}</span>
                                </OverlayTrigger>                    
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4 label'>
                                Address
                            </div>
                            
                            <div className='col-8 value'>
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(e)=> renderTooltip(e,`
                                        ${address[addressCount]?.address_line_1} 
                                        ${address[addressCount]?.address_line_2} 
                                        ${address[addressCount]?.city} 
                                        ${address[addressCount]?.county} , 
                                        ${address[addressCount]?.state} 
                                        ${address[addressCount]?.zipcode}
                                    `)}
                                    >
                                    <span variant="success">{
                                    (address[addressCount]?.address_line_1 || address[addressCount]?.address_line_2 || address[addressCount]?.city || address[addressCount]?.county || address[addressCount]?.state || address[addressCount]?.zipcode) 
                                    ?
                                        <>
                                            {`
                                                ${address[addressCount]?.address_line_1} 
                                                ${address[addressCount]?.address_line_2} 
                                                ${address[addressCount]?.city} 
                                                ${address[addressCount]?.county} , 
                                                ${address[addressCount]?.state} 
                                                ${address[addressCount]?.zipcode}
                                            `}
                                        </>
                                    :
                                        "-"
                                } </span>
                                </OverlayTrigger> 
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4 label'>
                                Lead source
                            </div>
                            <div className='col-8 value'>
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(e)=> renderTooltip(e,userDetail.lead_source)}
                                    >
                                    <span variant="success">{userDetail.lead_source ? userDetail.lead_source : "-"}</span>
                                </OverlayTrigger>                      
                            </div>
                        </div>
                        
                    </div>
                    
                    <div className='col-2 p-0 btn-container'>
                        <button className='address-btns mb-1' onClick={(e) => dispatch(EditCustomerLeadRecord(e , "editAdd", address[addressCount], addressCount , addressType))}>
                            <span className="cta-icon">Edit</span>
                            <span className='cta-text'>Edit</span>
                        </button>
                        {
                            address?.length > 1 &&
                                <button className='address-btns mb-1'
                                        onClick={e => dispatch( editUserAddress(e, "Remove" , "removeAddress" ,addressCount))}
                                        >
                                            <span className='cta-text'>Remove</span>
                                            <span class="cta-icon">Remove</span>
                                </button>
                        }
                        {
                                address[addressCount]?.is_default ?
                                <button className='address-btns mb-1 remove-cursor'>   <span className='cta-text'>Default</span> <span class="cta-icon">Default</span> </button>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

class ShowLeadDetails extends React.Component {
    constructor(props) {
        super(props);
        
    }

   render() {
    return (
        <>
            <div className="form-wrapper ">
                <div className="user-detail">
                {/* <div className="user-name">{this.props.LeadCustomerData.first_name} {this.props.LeadCustomerData.last_name}</div> */}
                <h4 className='page-title'>{this.props.is_module_name=="order"?'Customer Detail':'Lead/Customer Detail'}</h4>
                    <div classNames="user-detail-edit">
                        
                        {/* <div className='row'>
                            <div className='col-md-10'>
                                <h1 className='title mt-1'>Installation Address</h1>
                            </div>
                            <div className='col-md-2 text-right'>
                                <span className='title address-count'><span>{"<"}<span/>  1/4 </span> <span>{">"}</span></span>
                            </div>
                        </div> */}
                        <ShowAddressDetail detail={this.props} type="Installation"/>
                        {/* <div className='col-md-12 p-0'>
                            <div className='address-card flex'>
                                <div className='col-md-10'>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            First Name
                                        </div>
                                        <div className='col-md-8 value'>
                                            Jhony                                    
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Last Name
                                        </div>
                                        <div className='col-md-8 value'>
                                            Cage                                    
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Email
                                        </div>
                                        <div className='col-md-8 value email'>
                                            jhonycage@gmail.com                      
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Phone
                                        </div>
                                        <div className='col-md-8 value'>
                                            +1(336) 502-8308 958                     
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Address
                                        </div>
                                        <div className='col-md-8 value'>
                                            North Main Street Mount Airy, NC 27030     
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Lead source
                                        </div>
                                        <div className='col-md-8 value'>
                                            Call                                    
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-2 p-0 btn-container'>
                                    <button className='address-btns mb-1'>Edit</button>
                                    <button className='address-btns mb-1'>Remove</button>
                                </div>
                            </div>
                        </div> */}
                        
                        <ShowAddressDetail detail={this.props} type="Billing"/>
                        {/* <div className='row'>
                            <div className='col-md-10'>
                                <h1 className='title'>Billing Address</h1>
                            </div>
                            <div className='col-md-2 text-right address-count'>
                                <span className='title'><span>{"<"}<span/>  1/4 </span> <span>{">"}</span></span>
                            </div>
                        </div>
                        <div className='col-md-12 p-0'>
                            <div className='address-card flex'>
                                <div className='col-md-10'>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            First Name
                                        </div>
                                        <div className='col-md-8 value'>
                                            Jhony                                    
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Last Name
                                        </div>
                                        <div className='col-md-8 value'>
                                            Cage                                    
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Email
                                        </div>
                                        <div className='col-md-8 value email'>
                                            jhonycage@gmail.com                      
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Phone
                                        </div>
                                        <div className='col-md-8 value'>
                                            +1(336) 502-8308 958                     
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Address
                                        </div>
                                        <div className='col-md-8 value'>
                                            North Main Street Mount Airy, NC 27030     
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4 label'>
                                            Lead source
                                        </div>
                                        <div className='col-md-8 value'>
                                            Call                                    
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-2 p-0 btn-container'>
                                    <button className='address-btns mb-1'>Edit</button>
                                    <button className='address-btns mb-1'>Remove</button>
                                </div>
                            </div>
                        </div> */}

                    </div>

                    <div className='col-md-12 add-new-address-btn mt-4' onClick={(e) => this.props.AddCustomerLeadRecord(e,"openAdd")}>
                        <span> + Add New Address</span>
                    </div>                    
                
                    <div className='row mt-4'>
                        {
                            this.props.searchData?.length>0
                                ?
                                <div className='col-6 text-left change-selection-back' onClick={e =>
                                            this.props.AddCustomerLeadRecord(e,"back")} >
                                    <span className="icon-arrow-s2 mr-1"></span>
                                    <span>Change Selection</span>
                                </div>
                                :
                                null                            
                        }
                        <div className={this.props.searchData.length>0 ? 'col-6 text-right' : 'col-12 text-right'}>
                            <div className='more-info-btn justify-content-end'>
                                <button className='btn btn-primary' id="leadcustomerok" onClick={(e) => this.props.AddCustomerLeadRecord(e,"create")}>          
                                    <span className="text text-uppercase">Done</span>
                                </button>
                            </div>    
                        </div>
                    </div>

                    {/* <button type="button" onClick={e => this.props.AddCustomerLeadRecord(e,"back")} className="btn btn-white-shadow ">    
                            <span className="icon-arrow-s2"></span>                                    
                            <span className="text ml-1">{(Object.keys(this.props.searchData).length<=0)?"Change Selection":"Back"}</span>
                        
                        </button> */}

                    {/* <ul className="user-email-phone d-none">
                        <li>
                            {this.props.LeadCustomerData.email_2!=null && this.props.LeadCustomerData.isEdit!=true ?
                                <span>{this.props.LeadCustomerData.email_2}</span>
                                :<div className="info-block">
                                
                                {(this.props.LeadCustomerData.isEdit!=true)?
                                    <div className="title">NA <a onClick={(e)=>this.props.commonsActionforLeadCustomer(e.target.value,"Edit_Email")}><span className="icon-content"></span></a></div>
                                : <div id="configuration2" name="configuration2">
                                    <div className="edit-email">
                                        <div className={(this.props.displayerrorMessage.email_2 == '' || this.props.displayerrorMessage.email_2 == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}>
                                            <TextField
                                            label="Email"
                                            className="astrick"
                                            name="email"
                                            value={this.props.LeadCustomerData.email_2}
                                            onChange={e => this.props.onTextFiledChangeValue(e, 'email_2', 'Email','LeadCustomer','','editEmail')}
                                                />
                                            <div className="errorMessage" id="emailErrorMessage">{this.props.displayerrorMessage.email_2}</div>
                                        </div>
                                        <div className="icn-cnt">
                                            <button  onClick={(e)=>this.props.commonsActionforLeadCustomer(e.target.value,"close_Edit_Email")}><span className="icon-close"></span></button>
                                            <button  onClick={(e)=>this.props.commonsActionforLeadCustomer(e.target.value,"save_edit_Email")}><span className="icon-check"></span></button>
                                        </div>
                                    </div>
                                </div>
                                }
                                
                            </div>
                            }
                        </li>
                        <li>{this.props.LeadCustomerData.phone_no}</li>
                    </ul> */}
                </div>
                {/* <AddEditBillingInfo/> */}
            </div>
        </>
 )
   }
}
const mapStateToProps = (state) => {
   return state.leadcustomerReducer
}


export default connect(
   mapStateToProps,
   actionCreator
)(ShowLeadDetails);                        